import { createSelectorCreator, defaultMemoize } from 'reselect';
import _isEqual from 'lodash/isEqual';

/* Checks for equality of objects before recomputing selector */
export const createDeepEqualitySelector = createSelectorCreator(
  defaultMemoize,
  _isEqual
);
